<template>
  <a-table
    rowKey="uid"
    :data-source="data"
    :pagination="{ currnet: params.page, pageSize: params.size, total }"
    @change="onPageChange"
  >
    <a-table-column key="age" title="应用图标" data-index="app_ico_url">
      <template slot-scope="url">
        <a-avatar shape="square" :size="64" :src="url" />
      </template>
    </a-table-column>
    <a-table-column key="app_name" title="应用名称" data-index="app_name" />
    <a-table-column
      key="app_package"
      title="应用包名"
      data-index="app_package"
    />
    <a-table-column key="action" title="操作">
      <template slot-scope="text, record">
        <a-button v-if="canBind" type="primary" @click="onBinding(record)">
          绑定
        </a-button>
        <a-button
          v-else-if="record.is_bind"
          type="danger"
          @click="onUnbinding(record)"
        >
          解绑
        </a-button>
        <a-button v-else type="primary" disabled> 绑定 </a-button>
      </template>
    </a-table-column>
  </a-table>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      canBind: false,
      data: [],
      total: 0,
      params: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("agents", ["getAgentApps", "bindApp", "unbindApp"]),
    async getApps(uid) {
      this.params.uid = uid;
      this.onPageChange({ current: 1 });
    },
    async onPageChange(pagination) {
      this.params.page = pagination.current;
      const response = await this.getAgentApps(this.params);
      if (response) {
        this.canBind = response.can_bind == 1;
        this.total = response.total;
        this.data = response.data;
        this.params = response.params;
      }
    },
    async onBinding(data) {
      const response = await this.bindApp({
        app_uid: data.uid,
        agent_uid: this.params.uid,
      });
      if (response.code == 200) {
        this.$message.success("绑定成功");
        this.onPageChange({ current: this.params.page });
      }
    },
    async onUnbinding(data) {
      const response = await this.unbindApp({
        app_uid: data.uid,
        agent_uid: this.params.uid,
      });
      if (response.code == 200) {
        this.$message.success("解绑成功");
        this.onPageChange({ current: this.params.page });
      }
    },
    async onSuccess() {
      this.$message.success("操作成功");
      this.modal.visible = false;
    },
  },
};
</script>

<style lang="less">
.ant-space-vertical {
  width: 100%;
}

.ant-card-body > .ant-table-wrapper {
  border-top: 1px solid #e8e8e8;
}

.ant-table-wrapper .ant-pagination {
  padding-left: 24px;
  padding-right: 24px;
}
</style>
